export default function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <section
      data-testid="page-header"
      className="relative bg-slate-50 border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="max-w-3xl">
          {eyebrow && (
            <div className="text-xs uppercase tracking-[0.22em] font-bold text-blue-700">
              {eyebrow}
            </div>
          )}
          <h1
            data-testid="page-header-title"
            className="mt-3 font-display font-black tracking-tight text-slate-900 text-4xl sm:text-5xl lg:text-6xl leading-[1.05]"
          >
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-2xl">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      <div className="stripe-divider" aria-hidden="true" />
    </section>
  );
}
